<template>
	<div>
		<!-- 大统华供应链人员登陆中 -->
		<!--
        <p> ticket:{{ticket}} </p>
        <p> destinationRoute:{{destinationRoute}} </p>
        -->
		<div class="img_wrap">
			<p><img class="" :src="loading" /></p>
		</div>

	</div>
</template>

<script>
	import loadingGif from '@/assets/images/loading.gif';
	import {
		findRouteByRouteName
	} from "../../router/index";
	import AuthApi from "../../api/smp/auth/Auth.js";
	import AuthUtil from "../../util/auth.js";

	export default {
		name: "Oa-Warn-Link-Login",
		data() {
			return {
				loading: loadingGif,
				ticket: "",
				destinationRoute: "",
			}
		},
		created: function() {
			console.log('oa warn link login created');
			this.login();
		},
		mounted: function() {
			console.log('oa warn link login mountted');
			//this.$router.push({name: "sm-provider-return-order-confirm",params:{page:{id:'341'}}});	
		},
		methods: {
			async login() {
				let me = this;

				this.mobile = this.$route.query.mobile;
				this.destinationRoute = this.$route.query.destinationRoute;

				//console.log(this.sm_provider_ticket+"-"+this.destinationRoute);
				if (!this.mobile || !this.destinationRoute) {
					this.$router.push({
						name: '500',
						params: {
							page: {
								id: -1
							}
						}
					});
					return;
				}

				let route = findRouteByRouteName(me.destinationRoute);
				console.log("==================")
				console.log(route)
				if (!route) {
					this.$router.push({
						name: '500',
						params: {
							message: '未找到路径'
						}
					});
					return;
				}
				// if (!route.meta || !route.meta.page || !route.meta.page.id) {
				// 	this.$router.push({
				// 		name: '500',
				// 		params: {
				// 			message: '路径配置错误'
				// 		}
				// 	});
				// 	return;
				// }

				try {
					let accessToken = await this.oaWarnLinkLogin(this.mobile);

					AuthUtil.setAccessToken(accessToken);
				} catch (err) {
					me.errMsg('错误', '获取或缓存令牌信息失败');
					return;
				}

				//console.log("routeing to destination:"+me.destinationRoute);
				//console.log(route.meta.page);
				this.$router.push({
					name: me.destinationRoute,
					params: {
						page: route.meta.page
					}
				});
			},
			async oaWarnLinkLogin(mobile) {
				console.log("mobile:" + mobile + " 开始登录");
				let resp = await AuthApi.oaWarnLinkLogin(mobile);

				//console.log("ticket login response:");
				//console.log(resp);
				let data = resp.data;
				if ((!data) || (!(data.code)) || (data.code != 200)) {
					let msg = data.msg;
					msg = ((!msg) || (msg == '')) ? '获取令牌失败' : msg;
					me.errMsg('错误', msg);
					return;
				}
				if ((!data.data.tokenInfo) || (!data.data.tokenInfo.access_token) || (data.data.tokenInfo.access_token == '')) {
					me.errMsg('错误', '获取令牌失败(无令牌数据)');
					return;
				}
				let accessToken = data.data.tokenInfo.access_token;

				return accessToken;
			},

			async errMsg(title, text) {
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
		},


	}
</script>

<style scoped>
	.img_wrap {
		position: absolute;
		left: 50%;
		margin-left: -150px;

	}
</style>
